import { gql, useQuery } from "@apollo/client"
import { EquityCartaStakeholderCollection } from "@oysterhr/schema"

const CARTA_ACCOUNTS_QUERY = gql`
  query CartaAccounts($companyId: ID!, $nextPageToken: String, $automaticMatching: Boolean) {
    equityCartaStakeholders(
      companyId: $companyId
      nextPageToken: $nextPageToken
      automaticMatching: $automaticMatching
    ) {
      stakeholders {
        id
        employeeId
        fullName
        email
        issuerId
        engagement {
          id
          teamMemberName
          cartaId
        }
      }
      nextPageToken
    }
  }
`

export const useCartaAccounts = (companyId: string, automaticMatching: boolean) => {
  return useQuery<{ equityCartaStakeholders: EquityCartaStakeholderCollection }>(
    CARTA_ACCOUNTS_QUERY,
    {
      variables: { companyId, automaticMatching },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "no-cache",
    },
  )
}
